import React, { Component } from "react";
import { getUserData } from "../../store/ducks/currentUser/actions";
import { postLogOut } from "../../store/ducks/auth/actions";
import { getCountUnreadInboxAlert } from "../../store/ducks/inbox/actions";
import { withRouter, NavLink, Link } from "react-router-dom";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Icon } from "@iconify/react";

import { getCountry } from "../../store/ducks/home/actions";
import { showBanner } from "../../store/ducks/banners/actions";




//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
let countries = [];
let langArr = [];
class PageHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headerBg: false,
            login: localStorage.getItem("accessToken") ? true : false,
            profileDropdwon: false,
            msgLoading: true,
            unreadMsgCnt: 0,
            loading: false,
            openModal: false,
            currentCountryImage: "MY",
            currentLanguageCode: "EN",
            reloadPage: false,
            username: ""
        };
    }

    componentDidMount() {
        const { t } = this.props;
        const savedUsername = localStorage.getItem("username");

        if(savedUsername){
            this.setState({ username: savedUsername });
        }

        const auth = localStorage.getItem("accessToken");
        if(auth){
            this.setState({ login: true })
        }

        this.props.getCountry();

        if (this.state.login) {
            let data = {};
            data.lang_id = this.props.currentUser.language_id;
            this.props.getCountUnreadInboxAlert(data);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;

        if (nextProps.logout_data !== this.props.logout_data) {
            if (nextProps.logout_data.responseCode === 200) {
                localStorage.removeItem("accessToken");
                localStorage.removeItem("username");
                localStorage.clear();

                window.location.reload();
            } else {
                return false;
            }
        }
        
        if (
            nextProps.unreadMessagesCnt !== undefined &&
            nextProps.unreadMessagesCnt !== this.props.unreadMessagesCnt
          ) {
            if (
              nextProps.unreadMessagesCnt.responseCode === 200 &&
              nextProps.unreadMessagesCnt.msgType === "success"
            ) {
              let unreadCnt = nextProps.unreadMessagesCnt.data.totalCount;
              unreadCnt = unreadCnt >= 99 ? 99 : unreadCnt;
              this.setState({
                msgLoading: false,
                unreadMsgCnt: unreadCnt,
              });
            }
        }

        if (nextProps.country_data !== undefined) {
            if (nextProps.country_data !== this.props.country_data) {
                let countryData = nextProps.country_data.country;
                let languageData = nextProps.country_data.language;
                // here

                //Clear the country array
                countries = [];
                langArr = [];

                Object.keys(countryData).map((item, i) => {
                    import(`../../assets/images/flags/${countryData[item].countryShortCode}.webp`).then((image) => {
                        if (this.props.currentUser.country_code === countryData[item].countryShortCode) {
                            this.setState({
                                currentCountryImage: image.default,
                                currentCountryShortCode: countryData[item].countryShortCode,
                                countryLoading: false,
                                currentLanguageCode: countryData[item].defaultLanguageCode.toUpperCase(),
                            });
                        }

                        if (localStorage.getItem("accessToken")) {
                            // if login & same country
                            if (this.props.currentUser.country_id === countryData[item].countryId) {
                                countries.push({
                                    image: image.default,
                                    countryId: countryData[item].countryId,
                                    countryName: countryData[item].countryName,
                                    countryCode: countryData[item].countryShortCode,
                                });
                            }
                        }
                        else {
                            countries.push({
                                image: image.default,
                                countryId: countryData[item].countryId,
                                countryName: countryData[item].countryName,
                                countryCode: countryData[item].countryShortCode,
                            });
                        }

                        this.setState({
                            loading: true,
                        });
                    });

                    return countries;
                });

                Object.keys(languageData).map((item, i) => {
                    if(languageData[item].languageCode !== 'ms') // r77 hardcode remove bahasa melayu
                    {
                        return langArr.push({
                            languageId: languageData[item].languageId,
                            countryCode: languageData[item].countryShortCode,
                            code: languageData[item].languageCode,
                            desc: languageData[item].languageName,
                            displayLanguageName: languageData[item].displayLanguageName,
                            timezone: languageData[item].timezone,
                        });
                    }
                });
            }
        }
        return true;
    }

    componentDidUpdate(prevProps) {
        const savedLang = localStorage.getItem("lang");

        if (
            savedLang &&
            prevProps.currentUser !== this.props.currentUser &&
            this.props.currentUser.language_code !== savedLang
        ) {
            this.props.currentUser.language_code = savedLang.replace("_cn","-CN").toString();
        }
    }

    handleSignOutHandler = () => {
        this.props.postLogOut();
    };

    imageImport = (r) => {
        let images = {};
        r.keys().map((item) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    changeCountryHandler = (event, countryCode, countryId, languageId, languageCode, timezone) => {
        event.preventDefault();

        if (this.props.currentUser.length === 0) {
            const data = {};
            data.country_code = countryCode;
            data.country_id = countryId;
            data.language_code = languageCode;
            data.language_id = languageId;
            data.time_zone = timezone;
            data.member_group_id = this.props.currentUser.member_group_id;
            // here
            this.props.getUserData(data);
        } else {
            const data = this.props.currentUser;
            data.country_code = countryCode;
            data.country_id = countryId;
            data.language_code = languageCode;
            data.language_id = languageId;
            data.time_zone = timezone;
            data.member_group_id = this.props.currentUser.member_group_id;
            // here is that the goup id problem
            this.props.getUserData(data);
        }
        let la = languageCode.replace("-", "_").toString().toLowerCase();
        localStorage.setItem("lang", la || "en");
        this.props.i18n.changeLanguage(la);

        import(`../../assets/images/flags/${countryCode}.webp`).then((image) => {
            this.setState({
                currentCountryImage: image.default,
                currentCountryShortCode: countryCode,
                currentLanguageCode: languageCode.toUpperCase(),
                timezone: timezone,
                openModal: false,
            });
        });

        const showBannerData = {};
        showBannerData.country_id = countryId;

        // this.props.showBanner(showBannerData);

        localStorage.setItem("changeCountry", true);
        localStorage.removeItem('promosData');
        localStorage.removeItem('vipDetails');

        this.setState({
            reloadPage: true
        });
    };

    render() {
        const { t } = this.props;

        const img = this.imageImport(require.context("../../assets/images", false, /\.(png|jpe?g|svg)$/));
        const flags = this.imageImport(require.context("../../assets/images/flags", false, /\.(png|jpe?g|svg|webp)$/));
        const icons = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/));

        // console.log("current user data:", this.props.currentUser)
        // console.log("current lang:", this.state.currentLanguageCode)
        // console.log("login status:", this.state.login)
        // console.log("current username:", this.state.username)
        // console.log("lang arr:", langArr)
        // console.log("local storage lang:", localStorage.getItem("lang").replace("_", "-").toString().toLowerCase())


        return (
            <Auxiliary>
                <nav className={this.state.headerBg ? "navbar scrolled" : "navbar"}>
                    <div className="x-container">
                        <NavLink to={{ pathname: "/" }} className="navbar-brand">
                            <img src={img["x33-logo.png"]} alt="x33-logo" />
                        </NavLink>
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <NavLink to={{ pathname: "/commission-plan" }} className="nav-link" activeClassName="active">
                                    {t('commission-plan.commission-plan')}                                        
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to={{ pathname: "/products" }} className="nav-link" activeClassName="active">
                                    {t('info-centre.products')}                                        
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to={{ pathname: "/terms-and-conditions" }} className="nav-link" activeClassName="active">
                                    {t('referral.terms-and-conditions')}
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to={{ pathname: "/contact" }} className="nav-link" activeClassName="active">
                                    {t('contact-us.contact-us')}
                                </NavLink>
                            </li>                                          

                            {this.state.login ? 
                                <>
                                    <div className="nav-divider"></div>

                                    <li className="nav-item">
                                       <div 
                                            role="button" 
                                            className="language-select gap-2" 
                                            data-bs-toggle="modal"
                                            data-bs-target="#selectCountry"
                                            onClick={this.openChangeCountryModal}>
                                                <img src={flags[(this.props.currentUser.country_code) ? this.props.currentUser.country_code + ".webp" : this.state.currentCountryShortCode + ".png"]} alt="flags" />
                                                <p className="ml-2">{(this.props.currentUser.language_code) ? this.props.currentUser.language_code.toUpperCase() : this.state.currentLanguageCode}</p>
                                                {/* <i className="arrow down btn-text-icon-gray" /> */}
                                        </div>
                                    </li>
                                        <li className="nav-item">
                                            <div
                                                role="button"
                                                className="nav-user"
                                                onMouseEnter={() => {
                                                    this.setState({ profileDropdwon: true });
                                                }}
                                                onMouseLeave={() => {
                                                    this.setState({ profileDropdwon: false });
                                                }}
                                            >
                                                <p className="ml-2">{this.props.currentUser.username ? this.props.currentUser.username : this.state.username}</p>
                                                <img className={`nav-arrow ${this.state.profileDropdwon ? "active" : ""}`} src={img["arrow.png"]} alt="arrow" />
                                                <ul className={`nav-dropdown ${this.state.profileDropdwon ? "active" : ""}`}>
                                                    <li>
                                                        <NavLink to={{ pathname: "/personal-details" }}>
                                                            <img src={icons["personal.svg"]} alt="personal-details" />
                                                            <p>{t("page-header.personal-information")}</p>
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to={{ pathname: "/transaction-report" }}>
                                                            <img src={icons["transaction.svg"]} alt="transaction-history" />
                                                            <p>{t("page-header.transaction-history")}</p>
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to={{ pathname: "/betting-history" }}>
                                                            <img src={icons["betting.svg"]} alt="betting-history" />
                                                            <p>{t("page-header.betting-history")}</p>
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to={{ pathname: "/message-center" }}>
                                                            <img src={icons["message.svg"]} alt="messages" />
                                                            <p>{t("message.message")}</p>
                                                            {(() => {
                                                                if (!this.state.loading) {
                                                                    if (this.state.unreadMsgCnt > 0) {
                                                                        return <div className="badge">{this.state.unreadMsgCnt}</div>;
                                                                    } else {
                                                                        return null;
                                                                    }
                                                                }
                                                            })()}
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <button type="button" className="btn btn-outline-white mx-auto" onClick={this.handleSignOutHandler}>
                                                            {t("page-header.sign-out")}
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                    </li>
                                </>
                            : ( 
                                <>
                                    <li className="nav-item">
                                        <NavLink to={{ pathname: "/login" }}>
                                            <button className="btn btn-blue">{t('page-header.login')}</button>
                                            <button className="btn btn-white" style={{ marginBottom: "3px"}}>{t('page-header.register')}</button>
                                        </NavLink>
                                    </li>  
                                    <li className="nav-item">
                                        <div 
                                            role="button" 
                                            className="language-select gap-2" 
                                            data-bs-toggle="modal"
                                            data-bs-target="#selectCountry"
                                            onClick={this.openChangeCountryModal}>
                                                <img src={flags[(this.props.currentUser.country_code) ? this.props.currentUser.country_code + ".webp" : this.state.currentCountryShortCode + ".png"]} alt="flags" />
                                                <p className="ml-2">{(this.props.currentUser.language_code) ? this.props.currentUser.language_code.toUpperCase() : this.state.currentLanguageCode}</p>
                                                <i className="arrow down btn-text-icon-gray" />
                                        </div>
                                    </li>
                                </>                                                                                                                           
                            )}                                                                                            
                        </ul>                        
                    </div>                    
                </nav>    

                <div className="modal global-modal fade" id="selectCountry" tabIndex="-1" aria-labelledby="selectCountryLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered  modal-language-body">
                        <div className="modal-content">
                            <div className="modal-header">
                                <img src={img["global-language.svg"]} alt="language" />
                                <h5 className="modal-title text-uppercase" style={{ color: "#4a89fc", fontWeight: "600", marginTop: "auto"}} id="selectCountryLabel">
                                    {t("footer.region-language")}
                                </h5>
                                <Icon type="button" className="btn-close" icon="mdi:close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            {this.state.loading && (
                                <div className="modal-body">
                                    <ul>
                                        {countries &&
                                            countries.map((countryVal, index) => {
                                                return (
                                                    <li key={index}>                                                            
                                                        <div className="country">
                                                            <img src={countryVal.image} alt="my flags" />
                                                            <h6>{countryVal.countryName}</h6>
                                                        </div>
                                                        <div className="language">
                                                            {langArr &&
                                                                langArr.map((langVal, idx) => {
                                                                    if (countryVal.countryCode === langVal.countryCode) {
                                                                        if (idx === 0 && this.props.currentUser.length === 0) {
                                                                            return (
                                                                                <button
                                                                                    className="btn btn-gradient-blue"
                                                                                    key={idx}
                                                                                    onClick={(event) =>
                                                                                        this.changeCountryHandler(
                                                                                            event,
                                                                                            countryVal.countryCode,
                                                                                            countryVal.countryId,
                                                                                            langVal.languageId,
                                                                                            langVal.code,
                                                                                            langVal.timezone
                                                                                        )
                                                                                    }
                                                                                    data-bs-dismiss="modal"
                                                                                >
                                                                                    {langVal.displayLanguageName}
                                                                                </button>
                                                                            );
                                                                        }

                                                                        return (
                                                                            <button
                                                                                // className={`btn ${this.props.currentUser.language_id === langVal.languageId
                                                                                className={`btn ${
                                                                                    (localStorage.getItem("lang")?.toLowerCase() === "zh_cn" && langVal.languageId === 2) ||
                                                                                    (localStorage.getItem("lang")?.toLowerCase() === "en" && langVal.languageId === 1)
                                                                                    ? "btn-gradient-blue"
                                                                                    : "btn-white"
                                                                                    }`}
                                                                                key={idx}
                                                                                onClick={(event) =>
                                                                                    this.changeCountryHandler(
                                                                                        event,
                                                                                        countryVal.countryCode,
                                                                                        countryVal.countryId,
                                                                                        langVal.languageId,
                                                                                        langVal.code,
                                                                                        langVal.timezone
                                                                                    )
                                                                                }
                                                                                data-bs-dismiss="modal"
                                                                            >
                                                                                {langVal.displayLanguageName}
                                                                            </button>
                                                                        );
                                                                    } else {
                                                                        return null;
                                                                    }
                                                                })}
                                                        </div>                                                        
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>            
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    const { auth, home, banner } = state;

    return {
        country_data: home.country_data,
        currentUser: state.currentUser.data,
        logout_data: auth.logout_data,
        unreadMessagesCnt: state.inbox.count_unread_inbox_alert_data,
        // show_banner_data: banner.show_banner_data
    };
};

const mapDispatchToProps = {
    getUserData,
    postLogOut,
    getCountUnreadInboxAlert,
    getCountry,
    // showBanner
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withNamespaces("translation")(PageHeader)));
